import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Navbar from "../../../Navbar/Navbar";

const FormParadan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            SaveOldRasid,
            OR_joriDraw,
            OR_zhmarayBarez,
            OpenOldRasid,
            OR_del_dis,
            OR_nawiBarez,
            OR_briQarz,
            NewOldRasid,
            toanotherInput,
            OR_save,
            OR_open,
            SearchWakilOldRasid
          } = value;

          return (
            <>
              <Navbar />

              <div className="container py-5 mt-4">
                <div className="row justify-content-center">
                  {/* Form take moneyy */}
                  <div className="col-12 col-lg-7 col-xl-6 text-warning">
                    <div
                      className="card card-warning"
                      style={{
                        background:
                          "linear-gradient(145deg, #2C3539 0%, #1e272e 100%)",
                        border: "1px solid rgba(240, 173, 78, 0.35)",
                        borderRadius: "14px",
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
                        overflow: "hidden"
                      }}
                    >
                      <div
                        className="card-header p-3 border-bottom border-warning text-center"
                        style={{ backgroundColor: "transparent" }}
                      >
                        <h2 className="card-title tc mb-0">
                          <i className="fas fa-book-open ml3"></i>
                          داخیلکردنی قەرزی سەر دەفتەر
                        </h2>
                      </div>

                      <div className="card-body p-4">
                        <form>
                          {/* New / search action */}
                          <div className="d-flex justify-content-end mb-4">
                            <button
                              disabled={OR_del_dis == true ? true : null}
                              onClick={NewOldRasid}
                              className="btn btn-dark rounded-circle shadow-sm px-3 py-2"
                              title="نوێ"
                            >
                              <i className="fas fa-search-plus fa-lg"></i>
                            </button>
                          </div>

                          <div className="row">
                            <div className="col-12 col-md-7 text-right mb-3">
                              <div className="form-group mb-0">
                                <label className="font-weight-bold f4 d-block">
                                  <i className="fas fa-user ml2"></i>
                                  ناوی بەرێز
                                </label>
                                <input
                                  type="text"
                                  name="OR_nawiBarez"
                                  disabled={OR_del_dis == true ? true : null}
                                  onChange={AddProChange}
                                  value={OR_nawiBarez}
                                  className="form-control text-right font-weight-bold"
                                />
                              </div>
                            </div>

                            <div className="col-12 col-md-5 text-right mb-3">
                              <div className="form-group mb-0">
                                <label className="font-weight-bold f4 d-block">
                                  <i className="fas fa-hashtag ml2"></i>
                                  ژ.بەڕێز
                                </label>
                                <input
                                  type="text"
                                  name="OR_zhmarayBarez"
                                  onClick={NewOldRasid}
                                  disabled={OR_del_dis == true ? true : null}
                                  onChange={AddProChange}
                                  onKeyPress={(event) =>
                                    event.key == "Enter"
                                      ? SearchWakilOldRasid(
                                          event,
                                          OR_zhmarayBarez
                                        )
                                      : null
                                  }
                                  value={
                                    OR_zhmarayBarez == 0 ? "" : OR_zhmarayBarez
                                  }
                                  className="form-control text-right font-weight-bold"
                                />
                              </div>
                            </div>

                            <div className="col-12 col-md-6 text-right mb-3">
                              <div className="form-group mb-0">
                                <label className="font-weight-bold f4 d-block">
                                  <i className="fas fa-coins ml2"></i>
                                  جۆری دراو
                                </label>
                                <select
                                  className={`form-control text-right font-weight-bold selectpicker pull-right ${
                                    OR_joriDraw == "دۆلار"
                                      ? "bg-success text-white"
                                      : `${
                                          OR_joriDraw == "دینار"
                                            ? "bg-danger text-white"
                                            : ""
                                        }`
                                  } `}
                                  onKeyPress={(event) =>
                                    event.key == "Enter"
                                      ? toanotherInput(event)
                                      : null
                                  }
                                  disabled={OR_del_dis == true ? true : null}
                                  onChange={AddProChange}
                                  name="OR_joriDraw"
                                  value={OR_joriDraw != null ? OR_joriDraw : ""}
                                >
                                  <option className="ml5">..جۆری دراو</option>
                                  <option>دۆلار</option>
                                  <option>دینار</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-12 col-md-6 text-right mb-3">
                              <div className="form-group mb-0">
                                <label className="font-weight-bold f4 d-block">
                                  <i className="fas fa-money-bill-wave ml2"></i>
                                  بڕی قەرز
                                </label>
                                <NumberFormat
                                  displayType="input"
                                  thousandSeparator={true}
                                  name="OR_briQarz"
                                  onKeyPress={(event) =>
                                    event.key == "Enter"
                                      ? toanotherInput(event)
                                      : null
                                  }
                                  onChange={AddProChange}
                                  disabled={OR_del_dis == true ? true : null}
                                  value={OR_briQarz == 0 ? "" : OR_briQarz}
                                  className="form-control text-right font-weight-bold"
                                />
                              </div>
                            </div>

                            {/* Actions */}
                            <div className="col-12 d-flex justify-content-center align-items-start flex-wrap mt-3 pt-3 border-top border-warning">
                              {OR_save == null ? (
                                <>
                                  <div className="d-flex flex-column align-items-center ml3">
                                    <button
                                      type="button"
                                      onClick={SaveOldRasid}
                                      className="btn btn-md btn-success px-4 shadow-sm"
                                    >
                                      <i className="far fa-save fa-lg"></i>
                                    </button>
                                    <span className="font-weight-bold text-warning mt-2">
                                      خەزنکردن
                                    </span>
                                  </div>
                                  <button
                                    type="button"
                                    onClick={NewOldRasid}
                                    disabled={OR_open == true ? true : null}
                                    className="btn btn-md btn-primary px-4 ml3 shadow-sm"
                                  >
                                    <i className="far fa-file fa-lg"></i>
                                  </button>
                                </>
                              ) : (
                                <>
                                  {/* <button
                                    onClick={(e) => OpenOldRasid( e)}
                                    className="btn btn-md btn-warning px-4 ml3"
                                    style={{
                                      backgroundColor: "silver",
                                      border: "1px solid silver",
                                    }}
                                  >
                                    <i className="fas fa-lock"></i>
                                  </button> */}
                                  <button
                                    type="button"
                                    onClick={NewOldRasid}
                                    disabled={OR_open == true ? true : null}
                                    className="btn btn-md btn-primary px-4 ml3 shadow-sm"
                                  >
                                    <i className="far fa-file fa-lg"></i>
                                  </button>
                                </>
                              )}
                              {/* <div className="col-sm-8 ">



                                <button
                                  onClick={(e) =>
                                    PD_updtate_para(e, PD_wasl, PD_wasl.kascode)
                                  }
                                  className="btn btn-md btn-primary px-4 ml3"
                                  style={{ backgroundColor: "navy" }}
                                >
                                  <i className="fas fa-edit "></i>
                                </button>
                              </div> */}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default FormParadan;
